import { Ref, forwardRef } from 'react'
import { useParams } from 'react-router-dom'
import { DateTime } from 'luxon'
import { v4 as uuidv4 } from 'uuid'
import { DEFAULT_FOLDER_ID } from '../../../constants'
import { useCreateTask } from '../../../services/api/tasks.hooks'
import { DropType, TTaskV4 } from '../../../utils/types'
import CreateNewItemInput from '../../molecules/CreateNewItemInput'
import Task from '../../molecules/Task'
import { ViewHeader, ViewName } from '../styles'
import EmptyListMessage from './EmptyListMessage'
import { ViewItemsProps } from './viewItems.types'

const DueTodayViewItems = forwardRef(
    ({ view, visibleItemsCount, scrollRef, hideHeader }: ViewItemsProps, ref: Ref<HTMLDivElement>) => {
        const { overviewViewId, overviewItemId } = useParams()
        const { mutate: createTask } = useCreateTask()
        const dueTodayTasks = view.view_items as TTaskV4[]

        const onCreateNewTaskSubmit = (title: string, restore: () => void) => {
            createTask(
                {
                    title,
                    dueDate: DateTime.local().toISODate(),
                    id_folder: DEFAULT_FOLDER_ID,
                    optimisticId: uuidv4(),
                },
                { onError: restore }
            )
        }
        return (
            <>
                {!hideHeader && (
                    <ViewHeader ref={ref}>
                        <ViewName>{view.name}</ViewName>
                    </ViewHeader>
                )}
                <CreateNewItemInput
                    placeholder="Create new task"
                    submitLabel="Add task due today"
                    onSubmit={onCreateNewTaskSubmit}
                />
                {dueTodayTasks.length > 0 ? (
                    dueTodayTasks
                        .slice(0, visibleItemsCount)
                        .map((item, index) => (
                            <Task
                                key={item.id}
                                task={item as TTaskV4}
                                dropType={DropType.NON_REORDERABLE_TASK}
                                dragDisabled={false}
                                index={index}
                                isSelected={overviewViewId === view.id && overviewItemId === item.id}
                                sectionScrollingRef={scrollRef}
                                link={`/overview/${view.id}/${item.id}`}
                                isOverviewRow
                                animateSelection
                            />
                        ))
                ) : (
                    <EmptyListMessage list={view} />
                )}
            </>
        )
    }
)

export default DueTodayViewItems
